import { Dimensions, ScaledSize } from "react-native"
import { atom, useRecoilValue } from "recoil"

type NumericScreenSize = { width: number; height: number }

export function useNumericScreenSize(): NumericScreenSize {
  return useRecoilValue(screenSizeState)
}

const screenSizeState = atom({
  key: "screenSize",
  default: Dimensions.get("window"),
  effects: [
    ({ setSelf }) => {
      const handler = (dims: { window: ScaledSize; screen: ScaledSize }) => {
        setSelf(dims.window)
      }

      const screenSizeSubscription = Dimensions.addEventListener(
        "change",
        handler,
      )

      return () => screenSizeSubscription.remove()
    },
  ],
})
